<div *ngIf="!dynamicMap && !staticMap" class="no-map" fxFill fxLayout="column" fxLayoutAlign="center stretch">
	<span *ngIf="!(originAddress?.address1?.length > 0) && !(destAddress?.address1?.length > 0)">
			{{'placeOrderView.noMapAvailableText' | translate}}
			</span>
	<span *ngIf="(( originAddress?.address1?.length > 0 && (!originAddress?.lat || !originAddress?.lon)) ||
		(destAddress?.address1?.length > 0&& (!destAddress?.lat || !destAddress?.lon)))">
				{{'placeOrderView.cannotValidateAddressText' | translate}}
			</span>
</div>
<div *ngIf="dynamicMap && !hideDynamicMap" fxFlex fxLayout="column" fxLayoutAlign="start">
	<div *ngIf="showNote" class="map-note" fxLayout="row" fxLayoutAlign="center">
		Driving directions are informational only and may not represent actual driving directions.
	</div>
	<div fxFlex>
		<google-map [options]="options" height="100%" id="google-map" width="100%">
			<map-marker (mapDragend)="geocodeLatLng($event)" *ngFor="let marker of markers" [options]="marker?.options"
						[position]="marker?.position" [title]="marker?.title">
			</map-marker>
		</google-map>
	</div>
</div>
<div *ngIf="(staticMap && !staticMapUrl) || hideDynamicMap" class="no-map" fxFill fxLayout="column"
	 fxLayoutAlign="center stretch">
	<span>{{'routeTrackingSummaryView.mapUnavailableText' | translate}}</span>
</div>
<div *ngIf="staticMap && staticMapUrl" class="image-wrapper">
	<img alt="google map" height="100%" id="static-map" width="100%"/>
</div>
